const setGraphData_allunit = payload => {
  return {
    type: "setGraphData_allunit",
    payload
  };
};
export default setGraphData_allunit;
